import { DateTime } from 'luxon';

import { CompanyReportType } from '../../CompanyReport';
import { RecurringCompanyReport } from '../../RecurringCompanyReport';
import { Timezone } from '../../Time';
import { EDITED_REPORT_DELIVERY_HOUR } from '../EditedReportDeliveryHour';

export const FANNIE_MAE_TIMEZONE: Timezone = 'America/New_York' as const;
export const FANNIE_MAE_HOLIDAYS: DateTime[] = [
  DateTime.fromObject({ year: 2025, month: 1, day: 1 }),
  DateTime.fromObject({ year: 2025, month: 1, day: 20 }),
  DateTime.fromObject({ year: 2025, month: 2, day: 17 }),
  DateTime.fromObject({ year: 2025, month: 5, day: 26 }),
  DateTime.fromObject({ year: 2025, month: 6, day: 19 }),
  DateTime.fromObject({ year: 2025, month: 7, day: 4 }),
  DateTime.fromObject({ year: 2025, month: 9, day: 1 }),
  DateTime.fromObject({ year: 2025, month: 11, day: 11 }),
  DateTime.fromObject({ year: 2025, month: 11, day: 27 }),
  DateTime.fromObject({ year: 2025, month: 12, day: 25 }),
  DateTime.fromObject({ year: 2026, month: 1, day: 1 }),
  DateTime.fromObject({ year: 2026, month: 1, day: 19 }),
  DateTime.fromObject({ year: 2026, month: 2, day: 16 }),
  DateTime.fromObject({ year: 2026, month: 5, day: 25 }),
  DateTime.fromObject({ year: 2026, month: 6, day: 19 }),
  DateTime.fromObject({ year: 2026, month: 9, day: 7 }),
  DateTime.fromObject({ year: 2026, month: 10, day: 12 }),
  DateTime.fromObject({ year: 2026, month: 11, day: 11 }),
  DateTime.fromObject({ year: 2026, month: 11, day: 26 }),
  DateTime.fromObject({ year: 2026, month: 12, day: 25 }),
] as const;

export const FANNIE_MAE_DEFAULT_RECURRING_REPORT_VALUES: Record<
  | CompanyReportType.FANNIE_MAE_LAR_96_DAILY
  | CompanyReportType.FANNIE_MAE_LAR_96_MONTHLY
  | CompanyReportType.FANNIE_MAE_LAR_96_TRAILING
  | CompanyReportType.FANNIE_MAE_LAR_96_EDIT
  | CompanyReportType.FANNIE_MAE_CRS_DRAFT_REQUEST
  | CompanyReportType.FANNIE_MAE_CRS_DRAFT_REQUEST_EDIT
  | CompanyReportType.FANNIE_MAE_LAR_32
  | CompanyReportType.FANNIE_MAE_LAR_32_EDIT
  | CompanyReportType.FANNIE_MAE_LAR_81
  | CompanyReportType.FANNIE_MAE_LAR_81_EDIT
  | CompanyReportType.FANNIE_MAE_LAR_83
  | CompanyReportType.FANNIE_MAE_LAR_83_EDIT
  | CompanyReportType.FANNIE_MAE_LAR_89
  | CompanyReportType.FANNIE_MAE_LAR_89_EDIT
  | CompanyReportType.FANNIE_MAE_DELINQUENCY
  | CompanyReportType.FANNIE_MAE_DELINQUENCY_EDIT,
  Pick<RecurringCompanyReport, 'deliveryHour' | 'deliveryTimeZone' | 'title'> & { deliveryDay: number }
> = {
  FANNIE_MAE_LAR_96_DAILY: {
    deliveryHour: 4,
    deliveryTimeZone: FANNIE_MAE_TIMEZONE,
    deliveryDay: 0,
    title: 'Fannie Mae LAR 96 Daily',
  },
  FANNIE_MAE_LAR_96_MONTHLY: {
    deliveryHour: 5,
    deliveryTimeZone: FANNIE_MAE_TIMEZONE,
    deliveryDay: 22,
    title: 'Fannie Mae LAR 96 Monthly',
  },
  FANNIE_MAE_LAR_96_TRAILING: {
    deliveryHour: 5,
    deliveryTimeZone: FANNIE_MAE_TIMEZONE,
    deliveryDay: 1,
    title: 'Fannie Mae LAR 96 Trailing',
  },
  FANNIE_MAE_CRS_DRAFT_REQUEST: {
    deliveryHour: 4,
    deliveryTimeZone: FANNIE_MAE_TIMEZONE,
    deliveryDay: 0,
    title: 'Fannie Mae CRS Draft Request',
  },
  FANNIE_MAE_LAR_32: {
    deliveryHour: 4,
    deliveryTimeZone: FANNIE_MAE_TIMEZONE,
    deliveryDay: 0,
    title: 'Fannie Mae LAR 32',
  },
  FANNIE_MAE_LAR_81: {
    deliveryHour: 4,
    deliveryTimeZone: FANNIE_MAE_TIMEZONE,
    deliveryDay: 0,
    title: 'Fannie Mae LAR 81',
  },
  FANNIE_MAE_LAR_83: {
    deliveryHour: 4,
    deliveryTimeZone: FANNIE_MAE_TIMEZONE,
    deliveryDay: 0,
    title: 'Fannie Mae LAR 83',
  },
  FANNIE_MAE_LAR_89: {
    deliveryHour: 4,
    deliveryTimeZone: FANNIE_MAE_TIMEZONE,
    deliveryDay: 0,
    title: 'Fannie Mae LAR 89',
  },
  FANNIE_MAE_DELINQUENCY: {
    deliveryHour: 5,
    deliveryTimeZone: FANNIE_MAE_TIMEZONE,
    deliveryDay: 2,
    title: 'Fannie Mae Delinquency File',
  },
  FANNIE_MAE_LAR_96_EDIT: {
    deliveryHour: EDITED_REPORT_DELIVERY_HOUR,
    deliveryTimeZone: FANNIE_MAE_TIMEZONE,
    deliveryDay: 0,
    title: 'Fannie Mae LAR 96 (Edits)',
  },
  FANNIE_MAE_CRS_DRAFT_REQUEST_EDIT: {
    deliveryHour: EDITED_REPORT_DELIVERY_HOUR,
    deliveryTimeZone: FANNIE_MAE_TIMEZONE,
    deliveryDay: 0,
    title: 'Fannie Mae CRS Draft Request (Edits)',
  },
  FANNIE_MAE_LAR_32_EDIT: {
    deliveryHour: EDITED_REPORT_DELIVERY_HOUR,
    deliveryTimeZone: FANNIE_MAE_TIMEZONE,
    deliveryDay: 0,
    title: 'Fannie Mae LAR 32 (Edits)',
  },
  FANNIE_MAE_LAR_81_EDIT: {
    deliveryHour: EDITED_REPORT_DELIVERY_HOUR,
    deliveryTimeZone: FANNIE_MAE_TIMEZONE,
    deliveryDay: 0,
    title: 'Fannie Mae LAR 81 (Edits)',
  },
  FANNIE_MAE_LAR_83_EDIT: {
    deliveryHour: EDITED_REPORT_DELIVERY_HOUR,
    deliveryTimeZone: FANNIE_MAE_TIMEZONE,
    deliveryDay: 0,
    title: 'Fannie Mae LAR 83 (Edits)',
  },
  FANNIE_MAE_LAR_89_EDIT: {
    deliveryHour: EDITED_REPORT_DELIVERY_HOUR,
    deliveryTimeZone: FANNIE_MAE_TIMEZONE,
    deliveryDay: 0,
    title: 'Fannie Mae LAR 89 (Edits)',
  },
  FANNIE_MAE_DELINQUENCY_EDIT: {
    deliveryHour: EDITED_REPORT_DELIVERY_HOUR,
    deliveryTimeZone: FANNIE_MAE_TIMEZONE,
    deliveryDay: 0,
    title: 'Fannie Mae Delinquency File (Edits)',
  },
} as const;
